<template>
  <div class="input-item" :class="{ ['input-item__required']: required }">
    <label>{{label}}</label>
    <div class="input-wrap"><slot></slot></div>
  </div>
</template>

<script>
export default {
  name: 'InputItem',
  props: {
    // 输入标题
    label: {
      required: true
    },
    // 是否必填
    required: {
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.input-item {
  margin-bottom: 10px;
  label {
    flex-shrink: 0;
  }
  .input-wrap {
    & > * {
      width: 100%;
    }
  }
  &.input-item__required::before {
    content: '*';
    color: red;
  }
}
</style>
